import { render, staticRenderFns } from "./debug_panel.vue?vue&type=template&id=6cdcd3d5&scoped=true&"
import script from "./debug_panel.vue?vue&type=script&lang=js&"
export * from "./debug_panel.vue?vue&type=script&lang=js&"
import style0 from "./debug_panel.vue?vue&type=style&index=0&id=6cdcd3d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdcd3d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260415121604/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cdcd3d5')) {
      api.createRecord('6cdcd3d5', component.options)
    } else {
      api.reload('6cdcd3d5', component.options)
    }
    module.hot.accept("./debug_panel.vue?vue&type=template&id=6cdcd3d5&scoped=true&", function () {
      api.rerender('6cdcd3d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/debug/debug_panel.vue"
export default component.exports